import { Box, Stack } from "@mui/material";
import { Dispatch, SetStateAction } from "react";
import DisplayErrors from "src/components/display-errors";
import Iconify from "src/components/iconify/iconify";
import TruxFormField from "src/components/inputs/trux-form-field";
import TruxTextField from "src/components/inputs/trux-text-field";
import SimpleDialog from "src/components/simple-dialog";
import { ModelSavingData } from "src/hooks/use-model-saving-data";
import { RentalCustomer } from "src/models";
import TruxCheckboxField from "src/components/inputs/trux-checkbox-field";
import TruxSimpleTextField from "src/components/inputs/trux-simple-text-field";

type RentalCustomerModalProps = {
  selectedRentalCustomerModel: ModelSavingData<RentalCustomer>,
  isOpen: boolean,
  setIsOpen: Dispatch<SetStateAction<boolean>>,
  updateRentalCustomer: VoidFunction,
}

export function RentalCustomerModal(
  { selectedRentalCustomerModel, isOpen, setIsOpen, updateRentalCustomer }: RentalCustomerModalProps
) {

  return selectedRentalCustomerModel.model && <SimpleDialog
    title={<>{selectedRentalCustomerModel.isNew ? "New Customer" : "Update Customer"}</>}
    open={isOpen}
    size="medium"
    onCancel={() => {
      setIsOpen(false);
    }}
    onSubmit={updateRentalCustomer}
    submitDisabled={selectedRentalCustomerModel.loading}
    submitButton={selectedRentalCustomerModel.isNew ? "New Customer" : "Update Customer"}
    submitButtonIcon={selectedRentalCustomerModel.isNew ? <Iconify icon="mingcute:add-line" /> : <Iconify icon="basil:save-solid" />}
    submitButtonColor={selectedRentalCustomerModel.isNew ? "success" : "info"}>


    <DisplayErrors savingData={selectedRentalCustomerModel} />

    <Stack direction="column" gap={1}>

      <TruxFormField label="Company">
        <TruxTextField modelSavingData={selectedRentalCustomerModel} field="companyName" />
      </TruxFormField>

      <TruxFormField label="First Name">
        <TruxTextField modelSavingData={selectedRentalCustomerModel} field="firstName" />
      </TruxFormField>

      <TruxFormField label="Last Name">
        <TruxTextField modelSavingData={selectedRentalCustomerModel} field="lastName" />
      </TruxFormField>

      <TruxFormField label="Address">
        <Stack spacing={1}>
          <Box display="flex" gap={2}>
            <Box flexGrow={1}>
              <TruxSimpleTextField label="Street 1" value={selectedRentalCustomerModel.model.address.street1} onChange={(val) => selectedRentalCustomerModel.update((rentalCustomer) => {
                rentalCustomer.address.street1 = val;
              })} />
            </Box>
            <Box flexGrow={1}>
              <TruxSimpleTextField label="Street 2" value={selectedRentalCustomerModel.model.address.street2} onChange={(val) => selectedRentalCustomerModel.update((rentalCustomer) => {
                rentalCustomer.address.street2 = val;
              })} />
            </Box>
          </Box>
          <Box display="flex" gap={2}>
            <Box flexGrow={1}>
              <TruxSimpleTextField label="City" value={selectedRentalCustomerModel.model.address.city} onChange={(val) => selectedRentalCustomerModel.update((rentalCustomer) => {
                rentalCustomer.address.city = val;
              })} />
            </Box>
            <Box flexGrow={1}>
              <TruxSimpleTextField label="State" value={selectedRentalCustomerModel.model.address.state} onChange={(val) => selectedRentalCustomerModel.update((rentalCustomer) => {
                rentalCustomer.address.state = val;
              })} />
            </Box>
            <Box flexGrow={1}>
              <TruxSimpleTextField label="Zip" value={selectedRentalCustomerModel.model.address.zip} onChange={(val) => selectedRentalCustomerModel.update((rentalCustomer) => {
                rentalCustomer.address.zip = val;
              })} />
            </Box>
          </Box>
        </Stack>
      </TruxFormField>

      <TruxFormField label="Phone">
        <TruxTextField modelSavingData={selectedRentalCustomerModel} field="phone" />
      </TruxFormField>


      <TruxFormField label="Email">
        <TruxTextField modelSavingData={selectedRentalCustomerModel} field="email" />
      </TruxFormField>

      <TruxFormField label="Username">
        <TruxTextField modelSavingData={selectedRentalCustomerModel} field="username" />
      </TruxFormField>

      <TruxFormField label="Password">
        <TruxTextField modelSavingData={selectedRentalCustomerModel} field="password" />
      </TruxFormField>

      <TruxFormField label="Comment">
        <TruxTextField modelSavingData={selectedRentalCustomerModel} field="comment" />
      </TruxFormField>

      <TruxFormField label="Active">
        <TruxCheckboxField modelSavingData={selectedRentalCustomerModel} field="active" />
      </TruxFormField>
    </Stack>
  </SimpleDialog >
}
